import React from "react";

function Header() {
  return (
    <header className="header">
      <h1>Video Recommendation</h1>
    </header>
  );
}

export default Header;
